export const capitalizeString = (str: string) => str[0].toUpperCase() + str.slice(1);

export const compareString = (a: string, b: string) => a.toLowerCase() === b.toLowerCase();

export const sortString = (a: string, b: string) => a.localeCompare(b);
